// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3n8O0","disabled":"FileBtn_disabled__2e3OP","warn":"FileBtn_warn__3Are7","fade":"FileBtn_fade__3dsOQ"};